<template>
  <div class="m-web-height max-w-[520px] w-full">
    <div class="blur-nav" :class="!isWebMobile ? 'pt-[30px]' : ''">
      <div class="nav">
        <div class="absolute mt-[14px] ml-[16px]">
          <button @click="onClickBackButton">
            <img class="close_button" :src="icon_close" />
          </button>
        </div>
        <div class="flex flex-row w-full py-[14px] px-[40px] justify-center">
          <div class="flex">
            <div class="body_5">{{ props.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="body" :class="!isWebMobile ? 'pt-[82px]' : 'pt-[52px]'">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useLayoutStore } from "@/stores/layoutStore";
import icon_close from "@/assets/icons/icon_close.svg";
import router from "@/router/index";

const layoutStore = useLayoutStore();

const props = defineProps({
  title: {
    type: String,
    required: false,
    default: "",
  },
  // 닫기(X) 동작 오버라이드. 지정하지 않으면 기본 뒤로가기.
  onClose: {
    type: Function,
    required: false,
    default: null,
  },
});

const isWebMobile = computed(() => {
  return layoutStore.isMobileSize;
});

// Action
const onClickBackButton = () => {
  if (props.onClose) {
    props.onClose();
  } else {
    router.back();
  }
};
</script>

<style scoped>
.nav {
  height: 52px;
  width: 100%;
  /* background: #fbfdff; */
  display: flex;
  align-content: center;
  overflow-y: hidden;
  /* z-index: 100; */
}
.close_button {
  width: 24px;
  height: 24px;
}
.body {
  height: 100%;
  overflow: auto;
  /* width: 100%; */

  -ms-overflow-style: none;
}
.body::-webkit-scrollbar {
  display: none;
}
</style>
